import { AgentEffectCommands } from "../effect";
import { FactionType } from "./FactionType";

const { BeneGesserit, Emperor, Fremen, Guild } = FactionType;

const { drawIntrigue, garnison, solaris, water } = AgentEffectCommands;

export const FactionRampBonus = {
  [Emperor]: garnison(2),
  [Guild]: solaris(3),
  [BeneGesserit]: drawIntrigue,
  [Fremen]: water(1),
};
